import { render, staticRenderFns } from "./edit-pos.vue?vue&type=template&id=74e3ffd1&scoped=true"
import script from "./edit-pos.vue?vue&type=script&lang=js"
export * from "./edit-pos.vue?vue&type=script&lang=js"
import style0 from "./edit-pos.vue?vue&type=style&index=0&id=74e3ffd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e3ffd1",
  null
  
)

export default component.exports